import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    //logErrorToMyService(error, errorInfo);
    console.log(error, errorInfo);
  }

  render() {
    //@ts-ignore
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (<div className="bg-white shadow sm:rounded-lg">
      <div className="px-4 py-5 sm:p-6">
        <h3 className="text-lg leading-6 font-medium text-gray-900">An error occured</h3>
        <div className="mt-2 max-w-xl text-sm text-gray-500">
          <p>Please try refreshing the page. If you continue to have trouble please contact our office for help with subscribing.</p>
        </div>
      </div>
    </div>)
    }

    return this.props.children;
  }
}

const embed = true;
const appAnchorElement = document.getElementsByClassName("wp-smartpublisher-shortcode")[0];
//@ts-ignore
const config = (appAnchorElement).dataset;
console.log("Config", config);
ReactDOM.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App embed={embed} config={config}/>
    </ErrorBoundary>
  </React.StrictMode>,
  appAnchorElement
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
